<template>
  <section class="form-container p-md-4 my-3 col-lg-5 col-md-7 col-10">
    <h2 class="text-center mb-4">{{ formLabel }} <span class="fs-6 text-secondary">({{ $appType.desc[formFields.appType.value] }})</span> </h2> 
    <ul class="nav nav-tabs mb-2" id="applicantTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="owner-tab" data-bs-toggle="tab" data-bs-target="#owner" type="button"
          role="tab">
          معلومات السائق
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="vehicle-tab" data-bs-toggle="tab" data-bs-target="#vehicle" type="button"
          role="tab">
          معلومات المركبة
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="documents-tab" data-bs-toggle="tab" data-bs-target="#documents" type="button"
          role="tab" :disabled="docsDisable">
          رفع المستندات
        </button>
      </li>
    </ul>
    <div class="tab-content overflow-hidden py-2" id="applicantTabsContent">
      <div class="tab-pane fade show active" id="owner" role="tabpanel">
        <form @submit.prevent="nextTab('vehicle-tab')">
          <div v-for="field in formFields" :key="field.id" class="mb-3">
            <div class="" v-show="field.type != 'hidden'" v-if="(typeof(field.visibility) == 'undefined' || (field.visibility == 1 && nationalityId == 1 || field.visibility == 0 && nationalityId > 1)) && field.tab == 'owner'">
              <label :for="field.id" class="form-label">{{ field.label }}</label>
              <select v-if="field.type == 'select'" class="form-select" :id="field.id" v-model="field.value"
                :required="field.required" :disabled="field.disabled ?? isDisabled">
                <option value="" data-hidden="true" :selected="(field.value) ? false : true" disabled>{{
                  field.placeholder }}</option>
                <option v-for="option in field.options" :key="option.id" :value="option.id">
                  {{ option[field.optionName] }}
                </option>
              </select>
              <div v-else-if="field.type == 'radio'" class="container justify-content-center">
                <div v-for="option in field.options" :key="option.id" class="form-check form-check-inline">
                    <input v-model="field.value" class="form-check-input" type="radio" id="type-export"  :value="option.id" :disabled="field.disabled ?? isDisabled"/>
                    <label class="form-check-label" for="search-nation">{{ option[field.optionName] }}</label>
                </div>
              </div>
              <input v-else :type="field.type" class="form-control" :id="field.id" v-model="field.value"
                :placeholder="field.placeholder ?? ''" :required="field.required" :disabled="field.disabled ?? isDisabled" />
            </div>
          </div>
          <button class="btn btn-primary w-100">التالي</button>
        </form>
      </div>
      <div class="tab-pane fade" id="vehicle" role="tabpanel">
        <form @submit.prevent="nextTab('documents-tab')">
          <div v-for="field in formFields" :key="field.id" class="mb-3">
            <div class="" v-show="field.type != 'hidden'" v-if="(typeof(field.visibility) == 'undefined' || (field.visibility == 1 && nationalityId == 1 || field.visibility == 0 && nationalityId > 1)) && field.tab == 'vehicle'">
              <label :for="field.id" class="form-label">{{ field.label }}</label>
              <select v-if="field.type == 'select'" class="form-select" :id="field.id" v-model="field.value"
                :required="field.required" :disabled="field.disabled ?? isDisabled">
                <option selected disabled>{{ field.placeholder }}</option>
                <option v-for="option in field.options" :key="option.id" :value="option.id">
                  {{ option[field.optionName] }}
                </option>
              </select>
              <div v-else-if="field.type == 'radio'" class="container justify-content-center">
                <div v-for="option in field.options" :key="option.id" class="form-check form-check-inline">
                    <input v-model="field.value" class="form-check-input" type="radio" id="type-export"  :value="option.id" :disabled="field.disabled ?? isDisabled"/>
                    <label class="form-check-label" for="search-nation">{{ option[field.optionName] }}</label>
                </div>
              </div>
              <input v-else :type="field.type" class="form-control" :id="field.id" v-model="field.value"
                :placeholder="field.placeholder ?? ''" :required="field.required" :disabled="field.disabled ?? isDisabled" />
            </div>
          </div>
          <button class="btn btn-primary w-100">التالي</button>
        </form>
      </div>
      <div class="tab-pane fade" id="documents" role="tabpanel">
        <form @submit.prevent="$parent.submitForm">
          <h2 class="text-center mb-4">رفع الصور</h2>
          <p class=""><b>ملاحظة : </b>يجب التقاط صور المستندات بشكل واضح وكامل (الصورة غير الواضحة قد تتسبب في رفض الطلب
            في المعبر)</p>
          <div v-for="(doc, index) in documents" :key="formFields.transTypeId.value + index" class="mb-4">
            <label :for="'file' + index" class="form-label text-warning fw-bold">{{
              doc.name
            }}</label>
            <input type="file" :id="'file' + index" @change="handleFileChange($event, index)" class="form-control" />
            <img v-if="doc.preview" :src="doc.preview" class="thumbnail" height="250px" />
          </div>
          <button id="submit-btn" type="submit" class="btn btn-success w-100" :disabled="isDisabled">
            حفظ
          </button>
        </form>
      </div>
      <button v-if="isDisabled && appStatus == 1" type="button" class="btn btn-secondary w-100 my-1" @click="edit">
        تعديل
      </button>
      <button v-if="isDisabled && appStatus == 2" type="submit" class="btn btn-secondary w-100 my-1" data-bs-toggle="modal" data-bs-target="#extendAppModal">
       طلب تمديد
      </button>
      <!-- <button v-if="isDisabled && appStatus == 2" type="submit" class="btn btn-secondary w-100 my-1" data-bs-toggle="modal" data-bs-target="#dropAppModal">
       طلب استثناء (اسقاط)
      </button> -->
    </div>
  </section>
</template>
<script>

import imageCompression from 'browser-image-compression';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "ApplicantForm",
  
  props: {
    formLabel: String,
    formFields: Object,
    documents: Array,
    nationalityId: String,
    isDisabled: {
      default: false,
      type: Boolean,
    },
    appStatus: {
      default: 1,
      type: Number,
    },
    docsDisable: {
      default: false,
      type: Boolean,
    },
  },
  //  data() {
  //   return {
  //     nationalityId : this.formFields.nationalityId.value,
  //   }
  // },
  methods: {
    nextTab(tabId) {
      document.getElementById(tabId).click();
      
    },
    /** */
    // handleFileChange(event, index) {
    //   const file = event.target.files[0];
    //   if (file && file.type.startsWith("image/")) {
    //     this.documents[index].file = file;
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       this.documents[index].preview = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   }
    // },

    async handleFileChange(event, index) {
      const file = event.target.files[0];
      if (!file || !file.type.startsWith("image/")){
         this.documents[index].preview = null
        this.$tempAlert("يجب أن يكون الملف المرفوع صورة", "warning");
        return;
      }
      try {
        const options = {
          maxSizeMB: 0.7,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedBlob = await imageCompression(file, options);

        // Create a new File from the Blob to retain name and type
        const extension = file.name.split('.').pop(); // e.g., "jpg"
        const newFileName = `image_${Date.now()}.${extension}`; // generate a name
        const compressedFile = new File([compressedBlob], newFileName, {
          type: compressedBlob.type,
        });

        // Save to the documents array
        this.documents[index].file = compressedFile;

        // Preview (optional)
        const reader = new FileReader();
        reader.onload = (e) => {
          this.documents[index].preview = e.target.result;
        };
        reader.readAsDataURL(compressedFile);

      } catch (error) {
        console.error("Image compression error:", error);
        this.$tempAlert("فشل تحميل الصورة", "warning");
      }
    },
    /** */

    edit(event) {
      document.querySelectorAll("input, select").forEach((e) => {
        e.disabled = false;
      });
      this.$emit('update:isDisabled', false);
      document.getElementById("submit-btn").disabled = false;
      event.target.style.display = "none";
    },
    /** */
    checkVisibility(v) {
      return (v == 0 )
    },
    /*******************************************************************************/
    
    /*********************************/
  }
}
</script>